import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'
import { rem } from 'polished'
import LuxPlusLogo from 'luxPlus/components/Logos/LuxPlusLogo'

const StyledLabel = styled.span`
  display: inline-flex;
  align-items: center;
  gap: ${rem(4)};
`

function LuxPlusMonthTakeoverFilterLabel() {
  return <StyledLabel>
    <FormattedMessage
      id="oZdx3Zo79AdfbXxZFOD9"
      defaultMessage="{logo} Member Event"
      description="Filter checkbox label for the LuxPlus+ Month campaign in search result filter panels"
      values={{ logo: <LuxPlusLogo colour="default" height={10} inline /> }}
    />
  </StyledLabel>
}

export default LuxPlusMonthTakeoverFilterLabel
